import React from 'react';

const NotFoundPage = () => {
    return (
        <div>
            404 - not found
        </div>
    );
};

export default NotFoundPage;
